export default {
	data() {
		return {
			isMounted: false,
			refsAvailable: false,
		};
	},
	computed: {
		refs() {
			return this.refsAvailable ? this.$refs : {};
		},
	},
	mounted() {
		this.isMounted = true;
		this.refsAvailable = true;
	}
};
